import { MdClose } from 'react-icons/md';
import React from 'react';

export const CloseToastIcon = () => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', padding: 0 }}>
      <MdClose size={24} color="rgba(146, 151, 162, 1)" />
    </div>
  );
};
